export const BIN_PACKING_READY_QUERY_PARAM = 'binPackingReady';
